'use client';

import { useBreakpoints } from '@/hooks/useBreakpoints';
import { formateNumber } from '@/lib/utils/currency';
import { Tooltip } from '@mantine/core';
import Image from 'next/image';
import { useState } from 'react';
import { useSelector } from 'react-redux';

// const formateNumber = (number) => {
//     return new Intl.NumberFormat('tr-TR', {
//         style: 'currency',
//         currency: 'TRY',
//     }).format(number);
// };

const UserBalance = () => {
    const { balance } = useSelector((state) => state.balance);

    const [isOpen, setIsOpen] = useState(false);
    const { xsDevice } = useBreakpoints();
    const balanceLength = balance && formateNumber(balance)?.length;
    const balanceMaxLength = xsDevice ? 12 : 5;
    const balanceInfo = (
        <div className="header_btn extra_space_x cursor_pointer" onClick={() => setIsOpen(!isOpen)}>
            <div className="btn_img">
                <Image src="/images/icons/balance.svg" height="22" width="22" alt="balance icon" className="dark-blue-filter" style={{height: "1.375rem", width: "1.375rem"}} />
            </div>

            <div className="btn_content">
                <span className="btn_text">{balanceLength > balanceMaxLength ? `${balance ? String(balance).slice(0, balanceMaxLength) : '0'}...` : formateNumber(balance) || '0'} </span>
            </div>
        </div>
    );
    return (
        <>
            {balanceLength > balanceMaxLength ? (
                <Tooltip label={formateNumber(balance)} arrowOffset={50} arrowSize={10} withArrow position="bottom" opened={isOpen}>
                    {balanceInfo}
                </Tooltip>
            ) : (
                balanceInfo
            )}
        </>
    );
};

export default UserBalance;
